<template>
  <div class="news-container">
    <!-- 顶部导航栏 -->
    <div class="top-navigation">
      <div class="nav-left">
        <div class="logo">
          <span class="logo-icon">📚</span>
          <span class="logo-text">Bookor News</span>
        </div>
      </div>
      <div class="nav-center">
        <div class="nav-item" @click="goToHomepage">首页</div>
        <div class="nav-item active">新闻动态</div>
        <div class="nav-item" @click="goToBlog">博客流</div>
        <div v-if="isLoggedIn" class="nav-item" @click="goToTipTap">Manote</div>
      </div>
      <div class="nav-right">
        <!-- 未登录显示登录按钮 -->
        <button v-if="!isLoggedIn" class="login-btn" @click="goToLogin">登录</button>
        
        <!-- 已登录显示用户头像 -->
        <div v-else class="user-avatar" @click="showLogoutConfirm">
          <img
            v-if="userInfo?.member_avatar"
            :src="userInfo.member_avatar"
            alt="用户头像"
          />
          <img v-else src="@/assets/editor/icon.png" alt="默认头像" />
        </div>
      </div>
    </div>


    <!-- 主要内容区域 -->
    <div class="news-content">
      <!-- 左侧：动态新闻 -->
      <div class="news-section left-section">
        <DynamicNews />
      </div>

      <!-- 中间：历史新闻 -->
      <div class="news-section middle-section">
        <TechNews />
      </div>

      <!-- 右侧：今日推荐 -->
      <div class="news-section right-section">
        <TodayRecommendation />
      </div>
      
      <!-- 右侧：公众号分类（已隐藏） -->
      <!-- <div class="news-section right-section" style="display: none;">
        <HotTopics />
      </div> -->
    </div>

    <!-- 退出登录确认弹窗 -->
    <el-dialog 
      :visible.sync="logoutConfirmVisible" 
      width="400px"
      :show-close="false"
      center
      custom-class="logout-dialog"
    >
      <div class="logout-dialog-content">
        <div class="logout-question">是否确认退出登录？</div>
        <div class="logout-buttons">
          <el-button class="cancel-btn" @click="logoutConfirmVisible = false">取消</el-button>
          <el-button class="confirm-btn" type="primary" @click="confirmLogout">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DynamicNews from './components/DynamicNews.vue'
import TechNews from './components/TechNews.vue'
import HotTopics from './components/HotTopics.vue'
import TodayRecommendation from './components/TodayRecommendation.vue'

export default {
  name: 'NewsIndex',
  components: {
    DynamicNews,
    TechNews,
    HotTopics,
    TodayRecommendation
  },
  // 确保这个页面不需要登录验证
  beforeRouteEnter(to, from, next) {
    // 无论是否登录都允许访问
    next()
  },
  data() {
    return {
      userInfo: null,
      logoutConfirmVisible: false
    }
  },
  computed: {
    isLoggedIn() {
      return !!this.userInfo && !!localStorage.getItem('authorization')
    }
  },
  created() {
    // 检查用户登录状态
    const userInfoStr = localStorage.getItem('userinfo')
    if (userInfoStr) {
      try {
        this.userInfo = JSON.parse(userInfoStr)
      } catch (e) {
        this.userInfo = null
      }
    }
  },
  methods: {
    goToHomepage() {
      this.$router.push('/')
    },
    goToBlog() {
      this.$router.push('/editor/mp3List')
    },
    goToTipTap() {
      this.$router.push('/editor/note?paperId=')
    },
    goToLogin() {
      this.$router.push('/login')
    },
    showLogoutConfirm() {
      this.logoutConfirmVisible = true
    },
    confirmLogout() {
      localStorage.removeItem('userinfo')
      localStorage.removeItem('authorization')
      this.$message({
        message: '已退出登录',
        type: 'success',
        duration: 1000
      })
      this.logoutConfirmVisible = false
      this.userInfo = null
      // 跳转到首页
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

.news-container {
  height: 100vh;
  background: #f8f9fa;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.top-navigation {
  background: white;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  
  .nav-left {
    .logo {
      display: flex;
      align-items: center;
      font-size: 20px;
      font-weight: bold;
      color: #2c3e50;
      
      .logo-icon {
        margin-right: 8px;
        font-size: 24px;
      }
      
      .logo-text {
        color: #3498db;
      }
    }
  }
  
  .nav-center {
    display: flex;
    gap: 40px;
    
    .nav-item {
      padding: 8px 16px;
      cursor: pointer;
      color: #666;
      font-size: 16px;
      transition: color 0.3s ease;
      
      &:hover {
        color: #3498db;
      }
      
      &.active {
        color: #3498db;
        font-weight: 500;
      }
    }
  }
  
  .nav-right {
    display: flex;
    align-items: center;
    
    .login-btn {
      background: #3498db;
      color: white;
      border: none;
      padding: 8px 20px;
      border-radius: 20px;
      cursor: pointer;
      font-size: 14px;
      transition: background 0.3s ease;
      
      &:hover {
        background: #2980b9;
      }
    }
    
    .user-avatar {
      cursor: pointer;
      transition: transform 0.2s ease;
      
      &:hover {
        transform: scale(1.05);
      }
      
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        object-fit: cover;
      }
    }
  }
}


.news-content {
  display: grid;
  grid-template-columns: 0.9fr 1.2fr 0.9fr; /* 中间变宽，两侧变窄 */
  gap: 30px;
  max-width: 1800px; /* 增加最大宽度 */
  margin: 0 auto;
  padding: 20px 40px; /* 增加左右内边距 */
  flex: 1; /* 占据剩余高度 */
  min-height: 0; /* 允许子元素缩小 */
  height: calc(100vh - 60px); /* 减去顶部导航栏高度 */
}

.news-section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%; /* 自动填充高度 */
  min-height: 0; /* 允许子元素缩小 */
  
  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .news-content {
    max-width: 1200px;
    padding: 20px;
  }
}

@media (max-width: 1200px) {
  .news-content {
    grid-template-columns: 1fr;
    gap: 15px;
    max-width: 800px;
  }
  
  .news-section {
    height: 500px; /* 移动端降低高度 */
  }
}

@media (max-width: 768px) {
  .top-navigation {
    padding: 0 20px;
    
    .nav-center {
      gap: 20px;
      
      .nav-item {
        font-size: 14px;
        padding: 6px 12px;
      }
    }
    
    .nav-right {
      .login-btn {
        padding: 6px 16px;
        font-size: 13px;
      }
      
      .user-avatar img {
        width: 35px;
        height: 35px;
      }
    }
  }
  
  
  .news-content {
    padding: 15px;
  }
  
  .news-section {
    height: 400px; /* 手机端进一步降低高度 */
  }
}

// 退出登录弹窗样式
:deep(.logout-dialog) {
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

:deep(.logout-dialog .el-dialog__header) {
  display: none;
}

:deep(.logout-dialog .el-dialog__body) {
  padding: 40px 30px 30px 30px;
}

.logout-dialog-content {
  text-align: center;
}

.logout-question {
  font-size: 18px;
  color: #333;
  margin-bottom: 30px;
  font-weight: 500;
  line-height: 1.5;
}

.logout-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.logout-buttons .el-button {
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 8px;
  min-width: 80px;
}

.cancel-btn {
  background: #f5f5f5;
  border-color: #d9d9d9;
  color: #666;
}

.cancel-btn:hover {
  background: #e6e6e6;
  border-color: #bfbfbf;
  color: #333;
}

.confirm-btn {
  background: #1890ff;
  border-color: #1890ff;
}

.confirm-btn:hover {
  background: #40a9ff;
  border-color: #40a9ff;
}
</style>
